import { useQuery } from '@tanstack/react-query';
import { clientApi } from "@/utils/api";
import { QUERY_KEYS } from '@/constants/queryKeys';
import { CACHED_TIME } from '@/constants/common';
import { useMemo } from 'react';
import { TCreateRecruitmentSourceReqDto, TCreateRecruitmentSourceResDto } from '@/api/services/main/recruitment-source/dtos/create-recruitment-source-req.dto';
import { TGetRecruitmentSourceListResDto } from '@/api/services/main/recruitment-source/dtos/get-recruitment-source-list.dto';

export const fetchRecruitmentSourceListApi = async (): Promise<TGetRecruitmentSourceListResDto> => {
  const rs = await clientApi.get<TGetRecruitmentSourceListResDto>("/recruitment-sources");
  return rs.data;
};

export const useGetRecruitmentSourceList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.PARTNER.FETCH_LIST],
    queryFn: () => fetchRecruitmentSourceListApi(),
    staleTime: CACHED_TIME,
    gcTime: CACHED_TIME,
  });

  const recruitmentSourceOptions = useMemo(
    () => (data ? data.data.map((item) => ({ label: item.recruitmentSourceName ?? '', value: item.id })) : []),
    [data],
  );

  return { data: data?.data ?? [], recruitmentSourceOptions, ...rest };
};

export const createRecruitmentSourceApi = async (payload: TCreateRecruitmentSourceReqDto): Promise<TCreateRecruitmentSourceResDto> => {
  const rs = await clientApi.post<TCreateRecruitmentSourceResDto>("/recruitment-sources", payload);
  return rs.data;
};
